export const COMMENTS_INPUT_MAX_WIDTH = '398px';
